module.exports = __webpack_public_path__ + "img/meal-prep.b232e3b8.jpg";